export const NEXT_YEARS_STYLE_ID = 'voxnela_next_years'

export function parseCurrentAge(text: string): number | null {
  const marked = text.match(/(?:\b|^)(\d{1,3})\s*(?:yaş(?:ında|ındayım|ım)?|years?\s*old|y\/o)\b/i)
  const leading = text.match(/(?:yaşım|yasim|i am|i'm)\s*(\d{1,3})\b/i)
  const bare = text.trim().match(/^(\d{1,3})$/)
  const age = Number(marked?.[1] ?? leading?.[1] ?? bare?.[1])
  return Number.isInteger(age) && age >= 13 && age <= 100 ? age : null
}

export function nextYearsTargets(currentAge: number): [number, number, number] {
  return [currentAge + 15, currentAge + 30, currentAge + 45]
}

export function nextYearsImagePrompt(
  currentAge: number,
  userBrief: string,
): string {
  const [firstAge, secondAge, thirdAge] = nextYearsTargets(currentAge)
  return [
    `CURRENT_AGE=${currentAge};TARGET_AGES=${firstAge},${secondAge},${thirdAge}`,
    `Create ONE image with exactly three portrait panels of the same person, at ages ${firstAge}, ${secondAge}, and ${thirdAge}, in that order. Do not include a present-day fourth portrait.`,
    userBrief ? `Additional user preferences: ${userBrief}` : '',
  ].filter(Boolean).join('\n')
}
